import { c as _c } from "react/compiler-runtime";
import { Box, BoxProps } from '@chakra-ui/react';
import { prefixLandingIllustrationIds, prepareLandingIllustrationSvg } from '@src/components/sco/GenericLP/prepareLandingIllustrationSvg';
import React from 'react';
export type GenericSVGProps = BoxProps & {
  /**
   * SVG markup strings from an LP-specific illustrations file
   * (e.g. `ADVISORS_LANDING_ILLUSTRATIONS`).
   */
  illustrations: readonly string[];
  /** Index into `illustrations`. */
  illustrationIndex: number;
  /**
   * Namespace for gradient/filter IDs so multiple illustrations can share a page.
   * Final IDs are `{idPrefix}{illustrationIndex}-…`. Defaults to `glp`.
   */
  idPrefix?: string;
};

/**
 * Renders an animated inline SVG from an LP-specific illustrations array.
 *
 * Keep markup in a per-LP file and pass that array in:
 *
 * ```tsx
 * <GenericSVG illustrationIndex={0} illustrations={ADVISORS_LANDING_ILLUSTRATIONS} />
 * ```
 */
export const GenericSVG: React.FC<GenericSVGProps> = t0 => {
  const $ = _c(15);
  let boxProps;
  let illustrationIndex;
  let illustrations;
  let t1;
  if ($[0] !== t0) {
    ({
      illustrations,
      illustrationIndex,
      idPrefix: t1,
      ...boxProps
    } = t0);
    $[0] = t0;
    $[1] = boxProps;
    $[2] = illustrationIndex;
    $[3] = illustrations;
    $[4] = t1;
  } else {
    boxProps = $[1];
    illustrationIndex = $[2];
    illustrations = $[3];
    t1 = $[4];
  }
  const idPrefix = t1 === undefined ? "glp" : t1;
  const rawSvg = illustrations[illustrationIndex];
  if (!rawSvg) {
    return null;
  }
  let t2;
  if ($[5] !== idPrefix || $[6] !== illustrationIndex || $[7] !== rawSvg) {
    t2 = prefixLandingIllustrationIds(prepareLandingIllustrationSvg(rawSvg), `${idPrefix}${illustrationIndex}-`);
    $[5] = idPrefix;
    $[6] = illustrationIndex;
    $[7] = rawSvg;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const svg = t2;
  let t3;
  if ($[9] !== svg) {
    t3 = {
      __html: svg
    };
    $[9] = svg;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      "& svg": {
        display: "block",
        width: "100%",
        height: "auto"
      }
    };
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== boxProps || $[13] !== t3) {
    t5 = <Box bgColor="colorPalette.panel" border="1px solid" borderColor="colorPalette.border/50" borderRadius="2xl" dangerouslySetInnerHTML={t3} lineHeight={0} overflow="hidden" padding={4} width="full" css={t4} {...boxProps} />;
    $[12] = boxProps;
    $[13] = t3;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
export default GenericSVG;